import { render, staticRenderFns } from "./ChatRoomHeader.vue?vue&type=template&id=43cd5f7a&"
import script from "./ChatRoomHeader.vue?vue&type=script&lang=js&"
export * from "./ChatRoomHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports